import type { CloudGraphDealEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI: CloudGraphDealEntityAti[] = [
	'ati:cloud:graph:deal',
];
